<template>
  <CardInteractive :title="''" :info="''" :enableFullscreen="true" :isLoading="data?.isLoading">
    <template v-if="data?.isLoading">
      <div class="loader-container">
        <PulseLoader :loading="true" color="#3F46D6" />
      </div>
    </template>
    <template v-else-if="data?.error">
      <div class="error">
        <TextBase :text="data?.error" type="label" />
      </div>
    </template>
    <template v-else-if="!correctFilter">
      <div class="error">
        <TextBase v-if="correctFilter" :text="errorMessages?.NO_DATA[locale]" type="label" />
        <TextBase v-else :text="errorMessages?.INVALID_FILTER[locale]" type="label" />
      </div>
    </template>
    <template v-else>
      <TopList
        v-if="data?.data"
        :toplist="data?.data"
        :format="format"
        :barOptions="barOptions"
        :locale="locale"
      />
    </template>
  </CardInteractive>
</template>

<script lang="ts" setup>
import TopList, { BarConfiguration } from '@/components/AnalyticsDashboard/components/TopList.vue'
import CardInteractive from './CardInteractive.vue'
import { ToplistResponse } from '@/api-client/models/indoorclimate/Contracts'
import { FormatOptions } from '../formatter'
import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import { useDataSource } from '@/composables/useDataSources'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TextBase from '@/design-system/atoms/TextBase.vue'
import { EntityLevel, useEntityLevel } from '@/composables/useEntityLevel'
import { storeToRefs } from 'pinia'

type ErrorState = 'NO_DATA' | 'INVALID_FILTER'

type Props = {
  barOptions: BarConfiguration[]
  format: FormatOptions
  dataSource: string
  enabledEntityLevels?: EntityLevel[]
  errorMessages?: Record<ErrorState, string>
}

const props = defineProps<Props>()
const dataSourceId = ref(props.dataSource)
const dataSource = useDataSource<ToplistResponse>(dataSourceId)
const { entityLevel } = storeToRefs(useEntityLevel())
const data = computed(() => dataSource.value)

const correctFilter = computed(() => {
  if (props.enabledEntityLevels) {
    return props.enabledEntityLevels.includes(entityLevel.value)
  }
  return true
})

const { locale } = useI18n()
</script>

<style lang="css" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.error {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 100%;
}
</style>
